import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/site";

const INTERESTS = [
  "Fashion","Fitness","Beauty","Lifestyle","Travel","Photography","Modeling",
  "Music","Dance","Art","Gaming","Comedy","Cooking","Wellness","Editorial","Glamour"
];

export default function Interests() {
  const nav = useNavigate();
  const [picked, setPicked] = useState([]);
  const [busy, setBusy] = useState(false);
  const toggle = (i) => setPicked(p => p.includes(i) ? p.filter(x=>x!==i) : [...p, i]);

  const save = async () => {
    if (picked.length < 3) return toast.error("Pick at least 3 interests");
    setBusy(true);
    try {
      await api.post("/fan/interests", { interests: picked });
      toast.success("Great! Here are creators you'll love.");
      nav("/discover");
    } catch { toast.error("Could not save"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen pt-28 pb-16 px-6 max-w-3xl mx-auto" data-testid="interests">
      <h1 className="font-display text-4xl md:text-5xl text-white text-center">What are you into?</h1>
      <p className="mt-3 text-white/60 text-center">Pick at least 3 — we'll match you with the right creators.</p>
      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {INTERESTS.map((i) => {
          const on = picked.includes(i);
          return (
            <button key={i} onClick={() => toggle(i)} data-testid={`interest-${i.toLowerCase()}`}
              className={`p-4 rounded-lg border text-sm font-medium transition-all ${on ? "bg-brand text-white border-transparent" : "bg-white/5 border-white/10 text-white/80 hover:border-brand/50"}`}>
              {on && <Check size={14} className="inline mr-1.5" />}{i}
            </button>
          );
        })}
      </div>
      <div className="mt-10 flex items-center justify-between">
        <span className="text-white/50 text-sm">{picked.length} selected</span>
        <button onClick={save} disabled={busy || picked.length<3} data-testid="interests-continue"
          className="bg-brand text-white px-8 py-3 rounded-lg font-semibold flex items-center gap-2 disabled:opacity-40">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <>Continue <ArrowRight size={15} /></>}
        </button>
      </div>
    </div>
  );
}
